import { createRouter, createWebHistory } from 'vue-router'
import ReembolsoView from '../views/ReembolsoView.vue'
import RedirecionamentoView from '@/views/RedirecionamentoView.vue'
import SolicitacoesView from '@/views/SolicitacoesView.vue'
import RedirecionamentoSolicitacoesView from '@/views/RedirecionamentoSolicitacoesView.vue'
import SolicitacaoDetalhesView from '@/views/SolicitacaoDetalhesView.vue'

const routes = [
  { path: '/redirecionamento/:token?', component: RedirecionamentoView, props: true },
  { path: '/', component: ReembolsoView },
  { path: '/solicitacoes', component: SolicitacoesView },
  { path: '/redirecionamento/solicitacoes/:token?', component: RedirecionamentoSolicitacoesView, props: true },
  { path: '/solicitacao/:protocolo', name: 'Detalhes', component: SolicitacaoDetalhesView, props: true },
  {
    path: '/solicitacao-encerrada',
    name: 'SessaoEncerrada',
    component: () => import('../views/SessaoEncerradaView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
